var map = {
	"./chalk.json": "08ad",
	"./dark.json": "5d6b",
	"./essos.json": "2833",
	"./infographic.json": "5c46",
	"./macarons.json": "e2a13",
	"./purple-passion.json": "1978",
	"./roma.json": "9ac3",
	"./shine.json": "1c11",
	"./vintage.json": "1940",
	"./walden.json": "2a10",
	"./westeros.json": "915a",
	"./wonderland.json": "3386"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a536";